import { render, staticRenderFns } from "./LicenseDetails.vue?vue&type=template&id=343e855e"
import script from "./LicenseDetails.vue?vue&type=script&lang=js"
export * from "./LicenseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports